import { http } from '@uhg-abyss/web/tools/http';
import { event as eapmEvent } from '@uhg-abyss/web/tools/event';

export const verifyMedicaidRequest = async (payload) => {
  const { medicaidId, requestId, zip } = payload;
  const response = await http({
    method: 'POST',
    cache: false,
    withCredentials: true,
    url: `${payload.url}/provider/verifyMedicaid/v1`,
    handleError: async (err) => {
      const { error } = err.data;
      const { duration, endpoint, message, data, status } = err;
      const errorData = {
        status: data?.error?.code,
        message: data?.error?.description || message,
        code: status,
        duration,
        endpoint,
      };
      eapmEvent('EAPM_TRANSACTION_ERROR', errorData);
      const errObj = {
        error: { ...error, status: err.status },
      };

      return {
        data: {
          ...errObj,
        },
      };
    },
    body: {
      medicaidId,
      requestId,
      zip,
    },
  });
  const { duration, endpoint, status, data } = response;
  const successData = {
    endpoint,
    duration,
    status,
  };
  eapmEvent('EAPM_TRANSACTION_SUCCESS', successData);
  return data;
};
